// project imports
import config from "../config";

// action - state management
import * as actionTypes from "./actions";

interface CustomizationReducerState {
  isOpen: [];
  fontFamily: string;
  borderRadius: number;
  desktopOpen: boolean;
  mobileOpen: boolean;
}

export const initialState: CustomizationReducerState = {
  isOpen: [], // for active default menu
  fontFamily: config.fontFamily,
  borderRadius: config.borderRadius,
  desktopOpen: true,
  mobileOpen: false,
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action: any): any => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id],
      };
    case actionTypes.SET_DESKTOP_DRAWER:
      return {
        ...state,
        desktopOpen: action.desktopOpen,
      };
    case actionTypes.SET_MOBILE_DRAWER:
      return {
        ...state,
        mobileOpen: action.mobileOpen,
      };
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily,
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius,
      };
    default:
      return state;
  }
};

export default customizationReducer;
